// Centralised data-testid strings so tests + humans have one source of truth.
export const TID = {
    // Auth
    loginEmailInput: "login-email-input",
    loginRequestCodeBtn: "login-request-code-btn",
    loginCodeInput: "login-code-input",
    loginVerifyBtn: "login-verify-btn",
    loginPinInput: "login-pin-input",
    loginPinBtn: "login-pin-btn",
    loginBackBtn: "login-back-btn",
    logoutBtn: "logout-btn",
    setPinInput: "set-pin-input",
    setPinBtn: "set-pin-btn",
    skipPinBtn: "skip-pin-btn",

    // Hub
    hubTileDevPlan: "hub-tile-dev-plan",
    hubTileOperations: "hub-tile-operations",
    hubTileProduction: "hub-tile-production",
    hubTileScreenSaver: "hub-tile-screen-saver",
    hubTileLogistics: "hub-tile-logistics",

    // Common
    backToHubBtn: "back-to-hub-btn",

    // Board
    boardAddGroupBtn: "board-add-group-btn",
    boardAddItemBtn: (groupId) => `board-add-item-btn-${groupId}`,
    boardAddFirstItemBtn: (groupId) => `board-add-first-item-btn-${groupId}`,
    boardItemRow: (id) => `board-item-row-${id}`,
    boardGroupHeader: (id) => `board-group-header-${id}`,
    itemNameInput: "item-name-input",
    itemSaveBtn: "item-save-btn",
    itemDeleteBtn: "item-delete-btn",
    groupNameInput: "group-name-input",
    groupSaveBtn: "group-save-btn",

    // Operations
    opsScheduleAddBtn: "ops-schedule-add-btn",
    opsGoalAddBtn: "ops-goal-add-btn",
    opsScheduleRow: (id) => `ops-schedule-row-${id}`,
    opsGoalRow: (id) => `ops-goal-row-${id}`,

    // Screen Saver
    screenSaverUploadBtn: "screensaver-upload-btn",
    screenSaverFileInput: "screensaver-file-input",
    screenSaverPlayBtn: "screensaver-play-btn",
    screenSaverExitBtn: "screensaver-exit-btn",
    screenSaverVideoRow: (id) => `screensaver-video-row-${id}`,

    // Voice
    voiceOrb: "voice-orb",
    voiceOrbToggle: "voice-orb-toggle",
    voicePanel: "voice-panel",
    voiceCloseBtn: "voice-close-btn",
    voiceTextInput: "voice-text-input",
    voiceTextSend: "voice-text-send",
    voiceBriefingBtn: "voice-briefing-btn",
    voiceBriefingStopBtn: "voice-briefing-stop-btn",

    // Task expand overlay
    taskExpandOverlay: "task-expand-overlay",
    taskExpandCloseBtn: "task-expand-close-btn",
    taskExpandEditBtn: "task-expand-edit-btn",
    boardItemExpandBtn: (id) => `board-item-expand-btn-${id}`,
    boardItemIndex: (id) => `board-item-index-${id}`,

    // Logistics
    logisticsAddOrderBtn: "logistics-add-order-btn",
    logisticsOrderRow: (id) => `logistics-order-row-${id}`,
    logisticsOrderIndex: (id) => `logistics-order-index-${id}`,
    logisticsOrderExpandBtn: (id) => `logistics-order-expand-btn-${id}`,
    orderItemInput: "order-item-input",
    orderTrackingInput: "order-tracking-input",
    orderQtyInput: "order-qty-input",
    orderSaveBtn: "order-save-btn",
    orderDeleteBtn: "order-delete-btn",
    orderPasteToggleBtn: "order-paste-toggle-btn",
    orderPasteTextarea: "order-paste-textarea",
    orderPasteParseBtn: "order-paste-parse-btn",
    orderExpandOverlay: "order-expand-overlay",
    orderExpandCloseBtn: "order-expand-close-btn",

    // Hub extras
    hubTileFleet: "hub-tile-fleet",
    hubTileTrials: "hub-tile-trials",
    hubTileBd: "hub-tile-bd",
    hubTileAdmin: "hub-tile-admin",

    // Fleet
    fleetAddBtn: "fleet-add-vessel-btn",
    fleetVesselRow: (id) => `fleet-vessel-row-${id}`,
    vesselCallsignInput: "vessel-callsign-input",
    vesselSaveBtn: "vessel-save-btn",
    vesselDeleteBtn: "vessel-delete-btn",

    // Trials
    trialsAddBtn: "trials-add-btn",
    trialRow: (id) => `trial-row-${id}`,
    trialTitleInput: "trial-title-input",
    trialSaveBtn: "trial-save-btn",
    trialDeleteBtn: "trial-delete-btn",

    // BD Pipeline
    bdAddBtn: "bd-add-deal-btn",
    bdDealRow: (id) => `bd-deal-row-${id}`,
    dealClientInput: "deal-client-input",
    dealSaveBtn: "deal-save-btn",
    dealDeleteBtn: "deal-delete-btn",

    // Admin
    adminInviteBtn: "admin-invite-btn",
    adminInviteEmail: "admin-invite-email",
    adminInviteRoleBd: "admin-invite-role-bd",
    adminInviteRoleAdmin: "admin-invite-role-admin",
    adminInviteSubmit: "admin-invite-submit",
    adminUserRow: (id) => `admin-user-row-${id}`,
    adminToggleBd: (id) => `admin-toggle-bd-${id}`,
    adminToggleAdmin: (id) => `admin-toggle-admin-${id}`,
    adminDeleteUser: (id) => `admin-delete-user-${id}`,
    hubManageUsersBtn: "hub-manage-users-btn",

    // Help Menu
    helpMenuOpenBtn: "help-menu-open-btn",
    helpMenuCloseBtn: "help-menu-close-btn",
    helpMenuOverlay: "help-menu-overlay",
    helpTabSetup: "help-tab-setup",
    helpTabCommands: "help-tab-commands",

    // Fullscreen
    fullscreenToggleBtn: "fullscreen-toggle-btn",

    // Production Docs
    prodDocsBtn: "board-production-docs-btn",
    prodDocsPage: "production-docs-page",
    prodDocsSubsystemsPage: "production-docs-subsystems-page",
    prodDocsBrowsePage: "production-docs-browse-page",
    prodDocsUploadBtn: "production-docs-upload-btn",
    prodDocsFileInput: "production-docs-file-input",
    prodDocsRow: (id) => `production-docs-row-${id}`,
    prodDocsDownloadBtn: (id) => `production-docs-download-btn-${id}`,
    prodDocsDeleteBtn: (id) => `production-docs-delete-btn-${id}`,
    prodDocsAddPlatformBtn: "production-docs-add-platform-btn",
    prodDocsPlatformTile: (id) => `production-docs-platform-tile-${id}`,
    prodDocsPlatformDeleteBtn: (id) => `production-docs-platform-delete-${id}`,
    prodDocsPlatformNameInput: "production-docs-platform-name-input",
    prodDocsPlatformImageInput: "production-docs-platform-image-input",
    prodDocsPlatformCreateBtn: "production-docs-platform-create-btn",
    prodDocsSubsystemTile: (key) => `production-docs-subsystem-tile-${key}`,
    prodDocsSubsystemDeleteBtn: (key) => `production-docs-subsystem-delete-${key}`,
    prodDocsAddSubsystemBtn: "production-docs-add-subsystem-btn",
    prodDocsSubsystemNameInput: "production-docs-subsystem-name-input",
    prodDocsSubsystemImageInput: "production-docs-subsystem-image-input",
    prodDocsSubsystemCreateBtn: "production-docs-subsystem-create-btn",
    prodDocsAddFolderBtn: "production-docs-add-folder-btn",
    prodDocsFolderTile: (id) => `production-docs-folder-tile-${id}`,
    prodDocsFolderDeleteBtn: (id) => `production-docs-folder-delete-${id}`,
    prodDocsFolderNameInput: "production-docs-folder-name-input",
    prodDocsFolderCreateBtn: "production-docs-folder-create-btn",

    // Admin — docs role toggles
    adminToggleDocs: (id) => `admin-toggle-docs-${id}`,
    adminToggleDocsDl: (id) => `admin-toggle-docs-download-${id}`,
    adminInviteRoleDocs: "admin-invite-role-docs",
    adminInviteRoleDocsDl: "admin-invite-role-docs-download",

    // Admin — audit
    adminAuditNavBtn: "admin-audit-nav-btn",
    adminAuditPage: "admin-audit-page",
    adminAuditRow: (id) => `admin-audit-row-${id}`,
    adminInviteExternal: "admin-invite-allow-external",

    // Voice extras
    voiceAudioSettingsBtn: "voice-audio-settings-btn",

    // Fleet map
    fleetViewListBtn: "fleet-view-list-btn",
    fleetViewMapBtn: "fleet-view-map-btn",
    fleetMapContainer: "fleet-map-container",
    fleetMapPin: (id) => `fleet-map-pin-${id}`,
    vesselLatInput: "vessel-lat-input",
    vesselLngInput: "vessel-lng-input",
};
